import { useState, type ReactElement } from "react";
import { Box, Stack, Text, TextField, SearchIcon } from "@citibox-panel/ui";

// Two of the wrapper's three variants, and the two cases that cut across them: the boxed
// default, here carrying both adornments; `search` — the filled, frameless control the shell
// header's search box is; the multiline field the batch card ships, exercising `rows`,
// `helperText` and `monospace` at once; and the rejected-value state. The ⌘K hint stays as an
// adornment showcase; the header itself no longer draws one. `plain`, the dialog-header field, has
// never been catalogued here.
//
// The multiline case is catalogued exactly as the batch card ships it — rule as the LABEL, readout
// as the helper — so the showcase cannot drift from its only caller.
//
// The error case is PINNED rather than derived: a catalogue exists to show a treatment, and the
// rule that decides when a real field is in error belongs to the screen that owns the value, not
// to a showcase that would then hold a second copy of it.
export function TextFieldDemo(): ReactElement {
  const [value, setValue] = useState("");
  const [term, setTerm] = useState("");
  const [ids, setIds] = useState("");
  const [rejected, setRejected] = useState("LOC-8433");
  return (
    <Box sx={{ maxWidth: 360 }}>
      <Stack spacing={2}>
        <TextField
          aria-label="Buscar por teléfono"
          placeholder="Buscar por teléfono…"
          value={value}
          onChange={setValue}
          fullWidth
          startAdornment={<SearchIcon fontSize="small" />}
          endAdornment={
            <Text variant="caption" color="disabled">
              ⌘K
            </Text>
          }
        />
        <TextField
          aria-label="Buscar por dirección"
          placeholder="Buscar por dirección…"
          value={term}
          onChange={setTerm}
          variant="search"
          fullWidth
          startAdornment={<SearchIcon fontSize="small" />}
        />
        <TextField
          label="Un ID por línea. También acepta separación por comas."
          value={ids}
          onChange={setIds}
          multiline
          rows={8}
          monospace
          fullWidth
          placeholder={"8433\n8452\n8488"}
          helperText="2 IDs con formato válido · 1 descartado"
        />
        {/* What `error` buys is BOTH halves of the statement: the tinted frame for a sighted
            reader, and the `aria-invalid` MUI writes onto the input for everyone else. The tint
            stops at the frame — the helper keeps the body tone, because `error.main` clears the
            3:1 a border needs and not the 4.5:1 a 12px sentence does. */}
        <TextField
          aria-label="ID de ubicación"
          placeholder="ID de ubicación"
          value={rejected}
          onChange={setRejected}
          error
          monospace
          fullWidth
          startAdornment={<SearchIcon fontSize="small" />}
          helperText="El ID es un número, sin letras ni guiones"
        />
      </Stack>
    </Box>
  );
}
